@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img src="/assets/images/ambassadors_header.avif" class="w-full h-auto object-cover" alt="Background ambassadeurs" />
				<div class="absolute flex flex-row gap-10 justify-center w-full bottom-10 sm:bottom-10 md:bottom-10 lg:bottom-20 xl:bottom-30 2xl:bottom-40 3xl:bottom-60">

					<div class="flex flex-col leading-[45px] sm:leading-[110px] text-peps-dark-200 z-10">
						<div class=" flex flex-row justify-center">
							<span class="text-[52px] sm:text-[124px] md:text-[152px] lg:text-[196px] uppercase">{{ 'page.ambassadors.followers.count' | translate }}</span>
						</div>

						<div class=" flex flex-col sm:flex-row items-center leading-[20px] md:leading-normal md:gap-2 justify-center">
							<span class="text-[24px] sm:text-[72px] uppercase">{{ 'page.ambassadors.followers.text' | translate }}</span>
							<div class="flex flex-row gap-2">
								<svg class="w-6 h-6 sm:w-12 sm:h-12" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12.0011 0L3.42969 8.57143V39.4286H13.7154V48L22.2868 39.4286H29.144L44.5725 24V0H12.0011ZM41.144 22.2857L34.2868 29.1429H27.4297L21.4297 35.1429V29.1429H13.7154V3.42857H41.144V22.2857Z" fill="#F9ECEA"/>
									<path d="M36.0018 9.42871H32.5732V19.7144H36.0018V9.42871Z" fill="#F9ECEA"/>
									<path d="M26.5731 9.42871H23.1445V19.7144H26.5731V9.42871Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-6 h-6 sm:w-12 sm:h-12" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M47.5219 14.3996C47.5219 14.3996 47.0531 11.0902 45.6094 9.63711C43.7812 7.72461 41.7375 7.71523 40.8 7.60273C34.0875 7.11523 24.0094 7.11523 24.0094 7.11523H23.9906C23.9906 7.11523 13.9125 7.11523 7.2 7.60273C6.2625 7.71523 4.21875 7.72461 2.39062 9.63711C0.946875 11.0902 0.4875 14.3996 0.4875 14.3996C0.4875 14.3996 0 18.2902 0 22.1715V25.809C0 29.6902 0.478125 33.5809 0.478125 33.5809C0.478125 33.5809 0.946875 36.8902 2.38125 38.3434C4.20937 40.2559 6.60938 40.1902 7.67813 40.3965C11.5219 40.7621 24 40.8746 24 40.8746C24 40.8746 34.0875 40.8559 40.8 40.3777C41.7375 40.2652 43.7812 40.2559 45.6094 38.3434C47.0531 36.8902 47.5219 33.5809 47.5219 33.5809C47.5219 33.5809 48 29.6996 48 25.809V22.1715C48 18.2902 47.5219 14.3996 47.5219 14.3996ZM19.0406 30.2246V16.734L32.0062 23.5027L19.0406 30.2246Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-6 h-6 sm:w-12 sm:h-12" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M36.6526 3.80762H43.3995L28.6594 20.6546L46 43.5796H32.4225L21.7881 29.6757L9.61989 43.5796H2.86886L18.6349 25.5598L2 3.80762H15.9222L25.5348 16.5163L36.6526 3.80762ZM34.2846 39.5412H38.0232L13.8908 7.63388H9.87892L34.2846 39.5412Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-6 h-6 sm:w-12 sm:h-12" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-6 h-6 sm:w-12 sm:h-12" xmlns="http://www.w3.org/2000/svg" fill="#F9ECEA" viewBox="0 0 24 24" width="48" height="48">
									<path d="M7 2C4.239 2 2 4.239 2 7v10c0 2.761 2.239 5 5 5h10c2.761 0 5-2.239 5-5V7c0-2.761-2.239-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm10 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/>
								</svg>
							</div>

						</div>
					</div>

				</div>

			</div>
			<peps-separator></peps-separator>

		</div>
	</div>
	<div>
		<div class="w-6/12 mx-auto font-notosans text-justify z-10 mt-4">
			{{ 'page.ambassadors.text' | translate }}
		</div>
		<div class="relative mx-10">
			<div
				#slider
				class="scroll-smooth flex flex-nowrap py-20 gap-x-16 px-4 sm:px-6 lg:px-8 snap-x snap-mandatory overflow-x-hidden"
				(touchstart)="onTouchStart($event)"
				(touchmove)="onTouchMove($event)"
				(touchend)="onTouchEnd()"
			>
				@for (ambassador of ambassadors; track ambassador) {
					<peps-ambassador-card [ambassador]="ambassador"></peps-ambassador-card>
				}
			</div>

			@if(ambassadors.length > 1) {

				<button
					class="absolute left-0 top-1/3 -translate-y-1/2 z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 md:p-2.5 text-peps-dark-700"
					(click)="scrollSlider(-1)"
				>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 md:size-6 3xl:size-9">
						<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
					</svg>
				</button>

				<button
					class="absolute right-0 top-1/3 -translate-y-1/2 z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer  p-1.5 md:p-2.5 text-peps-dark-700"
					(click)="scrollSlider(1)"
				>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 md:size-6 3xl:size-9">
						<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
					</svg>
				</button>
			}

		</div>
		<peps-last-videos></peps-last-videos>

	</div>
}
